import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorManagerService } from '~/services/error-manager';
import { SecurityService } from '~/services/security.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private hasShownConflictError = false;
  private hasShownBadRequestError = false;
  constructor(
    private _securityService: SecurityService,
    private _errorManagerService: ErrorManagerService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError((err) => {
      // if (err.status === 401 && localStorage.getItem('accessToken')) {
      //   const pendingRequest = {
      //     request: request,
      //     next: next,
      //   };
      //   this._securityService.pendingRequests.push(pendingRequest);
      //   if (!this._securityService.isRefreshingToken) {
      //     this._securityService.refreshToken();
      //   }
      //   this._securityService.isRefreshingToken = true;
      // }

      if (err.status === 401) {
        const isRenderReport = window.location.pathname.toLowerCase().includes('renderreport');
        if (!isRenderReport) {
          if (localStorage.getItem('accessToken')) {
            localStorage.setItem('sessionEnded', "true")
          }
          this._securityService.removeLocalCredentials();
        }
      }

      if (err.error === 'Invalid_token') {
        const isRenderReport = window.location.pathname.toLowerCase().includes('renderreport');
        if (!isRenderReport) {
          this._securityService.removeLocalCredentials();
        }
      }

      // const error = (err && err.error && err.error.message) || err.statusText;
      let error = '';
      if (err.status === 409 && !this.hasShownConflictError) {
        this.hasShownConflictError = true;
        // this._layoutComponent.openPopup({
        //   title: 'Duplicate',
        //   message: err.error
        // });
        if (typeof (err?.error) == 'string') {
          this._errorManagerService.setError({
            title: 'Duplicate',
            message: err.error
          });
          error = err.error
        } else if (typeof (err?.error?.message) == 'string') {
          this._errorManagerService.setError({
            title: 'Duplicate',
            message: err.error?.message
          });
          error = err.error?.message;
        } else {
          this._errorManagerService.setError({
            title: 'Duplicate',
            message: 'Entity Already Exist'
          });
          error = 'Entity Already Exist';
        }

        setTimeout(() => {
          this._errorManagerService.setError(null);

          this.hasShownConflictError = false;
        });

        return throwError(error);
      }

      if (err.status === 400 && !this.hasShownBadRequestError) {
        let badRequestMessage = '';
        if (typeof err?.error === 'string') {
          badRequestMessage = err.error;
        } else if (typeof err?.error?.message === 'string') {
          badRequestMessage = err.error.message;
        } else if (typeof err?.error?.error === 'string') {
          badRequestMessage = err.error.error;
        } else if (typeof err?.error?.data === 'string') {
          badRequestMessage = err.error.data;
        } else if (typeof err?.error?.data?.message === 'string') {
          badRequestMessage = err.error.data.message;
        } else if (typeof err?.error?.title === 'string') {
          badRequestMessage = err.error.title;
          if (err?.error?.errors && typeof err.error.errors === 'object') {
            const details: string[] = [];
            for (const key of Object.keys(err.error.errors)) {
              const val = err.error.errors[key];
              if (Array.isArray(val)) {
                details.push(...val);
              } else if (typeof val === 'string') {
                details.push(val);
              }
            }
            if (details.length > 0) {
              badRequestMessage = details.join('<br/>');
            }
          }
        } else if (err?.error?.errors && typeof err.error.errors === 'object') {
          const details: string[] = [];
          for (const key of Object.keys(err.error.errors)) {
            const val = err.error.errors[key];
            if (Array.isArray(val)) {
              details.push(...val);
            } else if (typeof val === 'string') {
              details.push(val);
            }
          }
          if (details.length > 0) {
            badRequestMessage = details.join('<br/>');
          }
        }

        if (badRequestMessage) {
          this.hasShownBadRequestError = true;

          this._errorManagerService.setError({
            title: 'Error',
            message: badRequestMessage,
            withoutConfirm: true
          });
          error = badRequestMessage;

          setTimeout(() => {
            this._errorManagerService.setError(null);
            this.hasShownBadRequestError = false;
          });

          return throwError(error);
        }
      }

      // Re-throw all other errors (500, etc.) so subscribers can handle them
      return throwError(err);
    })
    );
  }
}
